import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NpsService } from '../../../service/nps.service';

@Component({
  selector: 'app-nps-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './nps-modal.component.html',
  styleUrl: './nps-modal.component.scss'
})
export class NpsModalComponent {
  constructor(public nps: NpsService) { }

  openGoogleReview(): void {
    window.open(this.nps.googleReviewUrl, '_blank', 'noopener');
    this.nps.closeThankYou();
  }
}
